<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Tạo dữ liệu kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-start flex-column align-items-start">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataDelivery.delivery_name.label"
                                        :id="dataDelivery.delivery_name.id"
                                        :placeholder="dataDelivery.delivery_name.placeholder"
                                        :value-default="dataDelivery.delivery_name.value"
                                        @inputValue="onChange($event, dataDelivery.delivery_name.id)"
                                        :error-text="dataDelivery.delivery_name.error"
                                        :is-error="dataDelivery.delivery_name.isError"
                                        @blur="validateForm($event, dataDelivery.delivery_name.id)"
                                        :required="dataDelivery.delivery_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataDelivery.store_id.label"
                                        :id="dataDelivery.store_id.id"
                                        :placeholder="dataDelivery.store_id.placeholder"
                                        :value-default="dataDelivery.store_id.value"
                                        @inputValue="onChange($event, dataDelivery.store_id.id)"
                                        :error-text="dataDelivery.store_id.error"
                                        :required="dataDelivery.store_id.required"
                                        :options="dataDelivery.store_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataDelivery.partner_id.label"
                                        :id="dataDelivery.partner_id.id"
                                        :placeholder="dataDelivery.partner_id.placeholder"
                                        :value-default="dataDelivery.partner_id.value"
                                        @inputValue="onChange($event, dataDelivery.partner_id.id)"
                                        :error-text="dataDelivery.partner_id.error"
                                        :required="dataDelivery.partner_id.required"
                                        :options="dataDelivery.partner_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextareaNormal
                                        :label="dataDelivery.delivery_description.label"
                                        :id="dataDelivery.delivery_description.id"
                                        :placeholder="dataDelivery.delivery_description.placeholder"
                                        :value-default="dataDelivery.delivery_description.value"
                                        @inputValue="onChange($event, dataDelivery.delivery_description.id)"
                                        :error-text="dataDelivery.delivery_description.error"
                                        :is-error="dataDelivery.delivery_description.isError"
                                        @blur="validateForm($event, dataDelivery.delivery_description.id)"
                                        :required="dataDelivery.delivery_description.required"
                                ></InputTextareaNormal>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-12 d-flex justify-content-between align-content-center mb-2">
                                    <label class="col-form-label" for="listProducts">SẢN PHẨM</label>
                                    <div class="col-sm-2">
                                        <button-add-component :width="'200px'" :label="labelSelectProduct" @click="showModalProductList"></button-add-component>
                                    </div>
                                </div>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="listProductsSelected.length > 0" v-for="(product, key) in listProductsSelected" :key="product.id">
                                        <td>{{key + 1}}</td>
                                        <td class="text-center">{{product.product_name}}</td>
                                        <td class="text-center">{{product.product_code}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.product_price, 'VND')}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.product_selling_price, 'VND')}}</td>
                                        <td class="text-center">{{product.product_tax + '%'}}</td>
                                        <td class="text-center">{{product.product_unit}}</td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="6" class="text-center">Chưa có sản phẩm được chọn!</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-12 d-flex  justify-content-center">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createDelivery"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalDeliveryProductListComponent
        @showModalProduct="showModalProduct($event)"
        @searchProduct="eventSearchProduct($event)"
        @listProductsSelectedCurrent="eventGetListProductsSelected($event)"
        :eventClickShowModal="eventClickShowModal"
        :listProductsSelected="listProductsSelected"
></ModalDeliveryProductListComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>
